"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3531],{

/***/ 3531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _adapters_cloudinary_adapters__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6508);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2221);
/* harmony import */ var _styles_components_ProductList_ProductList_tw_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8242);
/* harmony import */ var _helpers_sanitizationHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8948);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(754);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_constants_index__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);





const Card = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 5165).then(__webpack_require__.bind(__webpack_require__, 5165)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5165)
            ]
    }
});

const CardContent = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 5020).then(__webpack_require__.bind(__webpack_require__, 5020)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5020)
            ]
    }
});
const CardActions = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 3247).then(__webpack_require__.bind(__webpack_require__, 3247)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3247)
            ]
    }
});
const Button = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 8506).then(__webpack_require__.bind(__webpack_require__, 8506)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8506)
            ]
    }
});
const Typography = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 8766).then(__webpack_require__.bind(__webpack_require__, 8766)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8766)
            ]
    }
});
const ImageSet = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 3639).then(__webpack_require__.bind(__webpack_require__, 3639)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3639)
            ]
    }
});





class ProductListCard extends react__WEBPACK_IMPORTED_MODULE_1__.Component {
    render() {
        const { router , data  } = this.props;
        const { cardStyle , titleStyle , backgroundImage , textWrapper , imgWrapper , plpWrapper , linkStyle , plpImg , buynowwrapper , bestSellerTagWrapper , bestSellerTagWrapperNew , bestSellerTag , buyNowButton  } = _styles_components_ProductList_ProductList_tw_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].plpCard */ .Z.plpCard;
        const productShortName = (0,_helpers_sanitizationHelper__WEBPACK_IMPORTED_MODULE_7__/* .sanitize */ .N)(data.productName, true);
        /* ideally should be short name but presently snaitized full name*/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                height: "200px",
                once: true,
                offset: 100,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Card, {
                    className: cardStyle,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: data.exclusiveImage ? bestSellerTagWrapperNew : bestSellerTagWrapper,
                            children: [
                                data.bestSellerProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                                    component: "div",
                                    className: bestSellerTag,
                                    children: _constants_index__WEBPACK_IMPORTED_MODULE_8__.bestSellerText
                                }),
                                data.productShowExclusiveText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                                    component: "div",
                                    className: bestSellerTag,
                                    children: _constants_index__WEBPACK_IMPORTED_MODULE_8__.exclusive
                                }) : null,
                                data.exclusiveImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: "float-left h-20",
                                    src: (0,_adapters_cloudinary_adapters__WEBPACK_IMPORTED_MODULE_4__/* .getCdnImage */ .ZZ)(data.exclusiveImage.image.url, {
                                        w: 400
                                    }),
                                    alt: data.exclusiveImage.altText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardContent, {
                            className: plpImg,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: data.externalLink ? data.externalLink : data.slug,
                                className: "".concat(linkStyle) + " " + "".concat(data.bestsellerCarosuelGaClass ? data.bestsellerCarosuelGaClass : "event_view_more_details"),
                                "data-action-detail": data && data.productCategoryGaLabel ? "".concat(data.productCategoryGaLabel, "_click") : "".concat(productShortName, "_click"),
                                target: data.externalLink ? "_blank" : "_self",
                                rel: "noreferrer",
                                "aria-label": data === null || data === void 0 ? void 0 : data.heroImage.altText,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: imgWrapper,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(backgroundImage, "bg-".concat(data.listingCardBackgroundColour && data.listingCardBackgroundColour.toLowerCase())),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageSet, {
                                                content: data.heroImage,
                                                lazyload: true,
                                                isAriaHidden: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: textWrapper,
                                        children: data.productName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                                            component: "h2",
                                            className: titleStyle,
                                            children: data.productName
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: plpWrapper,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardActions, {
                                className: buynowwrapper,
                                children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: buyNowButton,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Button, {
                                        onClick: ()=>router.push("".concat(data.slug)),
                                        className: "primary-default-plp",
                                        gaClass: "event_buy_now",
                                        target: "_self",
                                        "aria-label": productShortName,
                                        "data-action-detail": "".concat(data.productCategoryGaLabel ? data.productCategoryGaLabel : productShortName + "_Buy"),
                                        children: [
                                            " ",
                                            _constants_index__WEBPACK_IMPORTED_MODULE_8__.learnMore
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            modal: false
        };
    }
}
ProductListCard.propTypes = {
    data: prop_types__WEBPACK_IMPORTED_MODULE_10___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object)
    ]).isRequired,
    storeLocatorData: prop_types__WEBPACK_IMPORTED_MODULE_10___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object)
    ]).isRequired,
    cardIndex: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    isMobile: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    length: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    router: prop_types__WEBPACK_IMPORTED_MODULE_10___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["default"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_9__.withRouter)(ProductListCard));


/***/ })

}]);